import { render } from "./LiveProjects.vue?vue&type=template&id=52e4cedd"
import script from "./LiveProjects.vue?vue&type=script&lang=js"
export * from "./LiveProjects.vue?vue&type=script&lang=js"

import exportComponent from "/Users/umar/Desktop/umi-portfolio-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__